module.exports = __webpack_public_path__ + "static/media/volume-slash.dc8e546d.svg";